export class SpgaCaptcha {
    codeId?:string;
    code?:string;
    isCaptchaReady?:boolean;
}
